module.exports = __webpack_public_path__ + "img/telephone.076cc7be.svg";